export default __webpack_public_path__ + "static/media/arrow-left.870cac9b.svg";